"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var destroyFns = [];
var _default = exports["default"] = destroyFns;